export const getCreateContentLabels = ({ isTeacher }: { isTeacher: boolean }) => {
    const title = isTeacher ? "Create something for your class!" : "Create";
    const desc = isTeacher ? "Navigate through the different categories" : "Navigate through the different categories";

    return { title, desc };
};
